<ng-container *ngIf="isLoading; else pageContent">
  <div class="auth-spinner">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <div class="auth-wrap">
    <div class="auth-left">
      <div>
        <a routerLink="/" class="auth-logo-row">
          <img
            src="assets/images/BeExpert-logo (3).svg"
            alt="BeExpert"
            class="auth-logo-img"
          />
        </a>

        <h1 class="auth-left-h1" style="font-size: 2.25rem; margin-bottom: 8px">
          Welcome to BeExpert.ai
        </h1>
        <h2
          style="
            font-size: 1.15rem;
            font-weight: 700;
            color: #fff;
            margin-bottom: 16px;
            line-height: 1.4;
          "
        >
          Your AI-powered platform for placement preparation, job opportunities,
          and hiring success.
        </h2>
        <p class="auth-left-sub" style="margin-bottom: 24px">
          Continue your journey toward becoming placement-ready with
          personalized learning, assessments, and AI-powered interviews.
        </p>

        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          Practice with AI-powered assessments and interviews
        </div>
        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          Access placement-focused courses and quizzes
        </div>
        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          Prepare for top companies with company-specific learning paths
        </div>
        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          Apply for jobs and opportunities that match your profile
        </div>
        <div class="auth-trust-item">
          <span class="auth-check-icon">✓</span>
          Track your progress and improve every day
        </div>
      </div>

      <div
        class="auth-stats-bar"
        style="
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 4px;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          padding-top: 20px;
        "
      >
        <span
          class="auth-stat-num"
          style="
            font-size: 1.2rem;
            font-weight: 800;
            color: #fff;
            border-right: none;
            text-align: left;
          "
          >1000+ Students Preparing for Placements</span
        >
        <span
          class="auth-stat-lbl"
          style="
            font-size: 0.8rem;
            color: rgba(255, 255, 255, 0.6);
            font-weight: 500;
            text-align: left;
          "
          >Start Free • Learn Faster • Get Hired</span
        >
      </div>
    </div>

    <div class="auth-right">
      <a routerLink="/" class="auth-mobile-bar">
        <img src="assets/images/beExpert.svg" alt="BeExpert" />
        <span class="mt-1 beexpert">BeExpert.ai</span>
      </a>
      <div class="auth-form-box">
        <ng-container *ngIf="forgotPasswordStep === 0; else forgotPasswordFlow">
          <div class="auth-form-title">Welcome back</div>
          <div class="auth-form-sub">
            Access your account using your preferred login method.
          </div>

          <div class="auth-tabs">
            <button
              type="button"
              class="auth-tab"
              [class.active]="loginMethod === 'password'"
              (click)="loginMethod = 'password'"
            >
              <i
                class="bi bi-key"
                *ngIf="loginMethod === 'password'"
                style="margin-right: 6px"
              ></i>
              Password
            </button>
            <button
              type="button"
              class="auth-tab"
              [class.active]="loginMethod === 'otp'"
              (click)="loginMethod = 'otp'"
            >
              <i
                class="bi bi-phone"
                *ngIf="loginMethod === 'otp'"
                style="margin-right: 6px"
              ></i>
              OTP
            </button>
          </div>

          <form
            [formGroup]="passwordForm"
            (ngSubmit)="onPasswordLogin()"
            *ngIf="loginMethod === 'password'"
          >
            <div class="auth-field">
              <label class="auth-label">Mobile Number or Email</label>
              <input
                type="text"
                class="auth-text-input"
                placeholder="Enter mobile number or email"
                formControlName="identifier"
                (input)="onIdentifierInput($event, passwordForm, 'identifier')"
              />
              <small
                class="auth-error"
                *ngIf="
                  passwordForm.get('identifier')?.invalid &&
                  (passwordForm.get('identifier')?.touched ||
                    passwordForm.get('identifier')?.dirty)
                "
              >
                <div
                  *ngIf="passwordForm.get('identifier')?.errors?.['required']"
                >
                  This field is required
                </div>
                <div
                  *ngIf="
                    passwordForm.get('identifier')?.errors?.[
                      'invalidPhoneLength'
                    ]
                  "
                >
                  Mobile number must be exactly 10 digits
                </div>
                <div
                  *ngIf="
                    passwordForm.get('identifier')?.errors?.[
                      'invalidPhoneStart'
                    ]
                  "
                >
                  Mobile number must start with 6, 7, 8, or 9
                </div>
                <div
                  *ngIf="
                    passwordForm.get('identifier')?.errors?.['invalidEmail']
                  "
                >
                  Please enter a valid email address
                </div>
              </small>
            </div>

            <div class="auth-field">
              <label class="auth-label">Password</label>
              <div class="auth-input-wrap">
                <span class="auth-icon-prefix"><i class="bi bi-lock"></i></span>
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  class="auth-icon-input"
                  placeholder="Enter your password"
                  formControlName="password"
                />
                <i
                  [class]="showPassword ? 'bi bi-eye' : 'bi bi-eye-slash'"
                  (mouseenter)="showPassword = true"
                  (mouseleave)="showPassword = false"
                  style="
                    position: absolute;
                    right: 15px;
                    top: 50%;
                    transform: translateY(-50%);
                    cursor: pointer;
                    color: #6c757d;
                    font-size: 1.2rem;
                  "
                ></i>
              </div>
              <small
                class="auth-error"
                *ngIf="
                  passwordForm.get('password')?.invalid &&
                  passwordForm.get('password')?.touched
                "
              >
                Password is required (min 8 characters)
              </small>
            </div>

            <div style="text-align: right; margin-bottom: 24px">
              <a
                (click)="goToForgotPassword()"
                style="
                  font-size: 0.82rem;
                  font-weight: 700;
                  color: #4a3fbf;
                  text-decoration: none;
                  cursor: pointer;
                "
                >Forgot Password?</a
              >
            </div>

            <button
              type="submit"
              class="auth-submit"
              [disabled]="passwordForm.invalid"
            >
              Login
            </button>
          </form>

          <form
            [formGroup]="otpForm"
            (ngSubmit)="onOtpLogin()"
            *ngIf="loginMethod === 'otp'"
          >
            <div class="auth-field">
              <label class="auth-label">Mobile Number or Email</label>
              <div
                class="auth-phone-wrap"
                style="
                  display: flex;
                  align-items: center;
                  border-radius: 11px;
                  overflow: hidden;
                  border: 1.5px solid #d1d9e0;
                "
              >
                <input
                  type="text"
                  formControlName="identifier"
                  class="auth-phone-input"
                  style="
                    flex: 1;
                    border: none;
                    padding: 13px 14px;
                    outline: none;
                    font-size: 0.875rem;
                  "
                  placeholder="Enter mobile number or email"
                  (input)="onIdentifierInput($event, otpForm, 'identifier')"
                />
                <button
                  type="button"
                  style="
                    border: none;
                    background: #f8f9ff;
                    color: #4a3fbf;
                    font-weight: 700;
                    padding: 0 16px;
                    align-self: stretch;
                    cursor: pointer;
                    font-size: 0.85rem;
                  "
                  [disabled]="otpForm.get('identifier')?.invalid"
                  (click)="onOtpLogin()"
                >
                  Send OTP
                </button>
              </div>
              <small
                class="auth-error"
                *ngIf="
                  otpForm.controls['identifier'].invalid &&
                  (otpForm.controls['identifier'].touched ||
                    otpForm.controls['identifier'].dirty)
                "
              >
                <div
                  *ngIf="otpForm.controls['identifier'].errors?.['required']"
                >
                  This field is required
                </div>
                <div
                  *ngIf="
                    otpForm.controls['identifier'].errors?.[
                      'invalidPhoneLength'
                    ]
                  "
                >
                  Mobile number must be exactly 10 digits
                </div>
                <div
                  *ngIf="
                    otpForm.controls['identifier'].errors?.['invalidPhoneStart']
                  "
                >
                  Mobile number must start with 6, 7, 8, or 9
                </div>
                <div
                  *ngIf="
                    otpForm.controls['identifier'].errors?.['invalidEmail']
                  "
                >
                  Please enter a valid email address
                </div>
              </small>
            </div>

            <button
              type="submit"
              class="auth-submit"
              [disabled]="otpForm.invalid"
            >
              Verify & Login
            </button>
          </form>

          <div class="auth-footer-link" style="margin-top: 16px">
            Don't have an account?
            <a [routerLink]="['/mobile-verify']" [queryParams]="{ redirectUrl: redirectUrl }">Sign up free</a>
          </div>
        </ng-container>

        <ng-template #forgotPasswordFlow>
          <!-- Back button and Stepper -->
          <ng-container
            *ngIf="forgotPasswordStep > 0 && forgotPasswordStep < 4"
          >
            <a
              (click)="forgotPasswordBack()"
              style="
                color: #4a3fbf;
                font-weight: 700;
                cursor: pointer;
                display: inline-flex;
                align-items: center;
                margin-bottom: 24px;
              "
            >
              &larr; Back
            </a>

            <div
              class="fp-stepper"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 32px;
                position: relative;
              "
            >
              <!-- Step 1 -->
              <div
                class="fp-step"
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  z-index: 1;
                  width: 50px;
                "
              >
                <div
                  *ngIf="forgotPasswordStep === 1"
                  style="
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    background-color: #4a3fbf;
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 700;
                    margin-bottom: 8px;
                  "
                >
                  1
                </div>
                <div
                  *ngIf="forgotPasswordStep > 1"
                  style="
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    background-color: #28a745;
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.2rem;
                    margin-bottom: 8px;
                  "
                >
                  <i class="bi bi-check"></i>
                </div>
                <span
                  [ngStyle]="{
                    color: forgotPasswordStep >= 1 ? '#4a3fbf' : '#6c757d',
                  }"
                  style="font-size: 0.75rem; font-weight: 700"
                  >Account</span
                >
              </div>

              <!-- Line 1-2 -->
              <div
                style="
                  flex: 1;
                  height: 2px;
                  background-color: #e9ecef;
                  margin: 0;
                  transform: translateY(-10px);
                "
              >
                <div
                  *ngIf="forgotPasswordStep > 1"
                  style="height: 100%; background-color: #28a745"
                ></div>
              </div>

              <!-- Step 2 -->
              <div
                class="fp-step"
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  z-index: 1;
                  width: 50px;
                "
              >
                <div
                  *ngIf="forgotPasswordStep < 2"
                  style="
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    background-color: #f8f9fa;
                    border: 1px solid #d1d9e0;
                    color: #6c757d;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 700;
                    margin-bottom: 8px;
                  "
                >
                  2
                </div>
                <div
                  *ngIf="forgotPasswordStep === 2"
                  style="
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    background-color: #4a3fbf;
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 700;
                    margin-bottom: 8px;
                  "
                >
                  2
                </div>
                <div
                  *ngIf="forgotPasswordStep > 2"
                  style="
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    background-color: #28a745;
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.2rem;
                    margin-bottom: 8px;
                  "
                >
                  <i class="bi bi-check"></i>
                </div>
                <span
                  [ngStyle]="{
                    color: forgotPasswordStep >= 2 ? '#4a3fbf' : '#6c757d',
                  }"
                  style="font-size: 0.75rem; font-weight: 700"
                  >Verify</span
                >
              </div>

              <!-- Line 2-3 -->
              <div
                style="
                  flex: 1;
                  height: 2px;
                  background-color: #e9ecef;
                  margin: 0;
                  transform: translateY(-10px);
                "
              >
                <div
                  *ngIf="forgotPasswordStep > 2"
                  style="height: 100%; background-color: #28a745"
                ></div>
              </div>

              <!-- Step 3 -->
              <div
                class="fp-step"
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  z-index: 1;
                  width: 50px;
                "
              >
                <div
                  *ngIf="forgotPasswordStep < 3"
                  style="
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    background-color: #f8f9fa;
                    border: 1px solid #d1d9e0;
                    color: #6c757d;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 700;
                    margin-bottom: 8px;
                  "
                >
                  3
                </div>
                <div
                  *ngIf="forgotPasswordStep === 3"
                  style="
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    background-color: #4a3fbf;
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 700;
                    margin-bottom: 8px;
                  "
                >
                  3
                </div>
                <span
                  [ngStyle]="{
                    color: forgotPasswordStep >= 3 ? '#4a3fbf' : '#6c757d',
                  }"
                  style="font-size: 0.75rem; font-weight: 700"
                  >Reset</span
                >
              </div>
            </div>
          </ng-container>

          <!-- Step 1: Account -->
          <ng-container *ngIf="forgotPasswordStep === 1">
            <div class="auth-form-title">Forgot password?</div>
            <div class="auth-form-sub">
              Enter your registered email to reset your password.
            </div>

            <form
              [formGroup]="forgotPasswordAccountForm"
              (ngSubmit)="submitForgotPasswordAccount()"
            >
              <div class="auth-field" style="margin-top: 24px">
                <label class="auth-label">Email</label>
                <input
                  type="email"
                  class="auth-text-input"
                  placeholder="Enter your email"
                  formControlName="identifier"
                />
                <small
                  class="auth-error"
                  *ngIf="
                    forgotPasswordAccountForm.get('identifier')?.invalid &&
                    (forgotPasswordAccountForm.get('identifier')?.touched ||
                      forgotPasswordAccountForm.get('identifier')?.dirty)
                  "
                >
                  <div
                    *ngIf="
                      forgotPasswordAccountForm.get('identifier')?.errors?.[
                        'required'
                      ]
                    "
                  >
                    This field is required
                  </div>
                  <div
                    *ngIf="
                      forgotPasswordAccountForm.get('identifier')?.errors?.[
                        'email'
                      ] ||
                      forgotPasswordAccountForm.get('identifier')?.errors?.[
                        'invalidEmail'
                      ]
                    "
                  >
                    Please enter a valid email address
                  </div>
                </small>
              </div>

              <button
                type="submit"
                class="auth-submit"
                [disabled]="forgotPasswordAccountForm.invalid"
              >
                Send OTP
              </button>
            </form>
          </ng-container>

          <!-- Step 2: Verify -->
          <ng-container *ngIf="forgotPasswordStep === 2">
            <div class="auth-form-title">Verify via OTP</div>
            <div class="auth-form-sub" style="margin-bottom: 24px">
              We've sent a 6-digit code to
              <strong>{{ forgotPasswordEmailOrPhone }}</strong
              >.
            </div>

            <div class="auth-field">
              <label class="auth-label">Enter OTP</label>
              <div
                class="otp-inputs"
                style="display: flex; gap: 10px; justify-content: space-between"
              >
                <input
                  *ngFor="
                    let v of forgotPasswordOtpValues;
                    let i = index;
                    trackBy: trackByIndex
                  "
                  [id]="'otp-input-' + i"
                  type="text"
                  maxlength="1"
                  inputmode="numeric"
                  autocomplete="one-time-code"
                  class="auth-text-input"
                  style="
                    width: 45px;
                    height: 50px;
                    text-align: center;
                    font-size: 1.2rem;
                    padding: 0;
                    border-radius: 8px;
                  "
                  [value]="forgotPasswordOtpValues[i]"
                  (input)="handleFpOtpInput($event, i)"
                  (keydown)="handleFpKeyDown($event, i)"
                  (paste)="handleFpOtpPaste($event)"
                />
              </div>
            </div>

            <div
              style="
                text-align: center;
                margin-bottom: 24px;
                font-size: 0.85rem;
              "
            >
              <span style="color: #6c757d">Didn't receive it? </span>
              <a
                (click)="resendFpOtp()"
                [ngStyle]="{
                  color:
                    resendCountdown > 0 || isResendingOtp
                      ? '#6c757d'
                      : '#4a3fbf',
                  cursor:
                    resendCountdown > 0 || isResendingOtp
                      ? 'not-allowed'
                      : 'pointer',
                }"
                style="font-weight: 700; text-decoration: none"
              >
                <ng-container *ngIf="isResendingOtp">Resending...</ng-container>
                <ng-container *ngIf="!isResendingOtp && resendCountdown > 0"
                  >Resend in {{ resendCountdown }}s</ng-container
                >
                <ng-container *ngIf="!isResendingOtp && resendCountdown === 0"
                  >Resend OTP</ng-container
                >
              </a>
            </div>

            <button
              type="button"
              class="auth-submit"
              [disabled]="!isFpOtpFilled()"
              (click)="submitForgotPasswordVerify()"
            >
              Verify
            </button>
          </ng-container>

          <!-- Step 3: Reset -->
          <ng-container *ngIf="forgotPasswordStep === 3">
            <div class="auth-form-title">Create new password</div>
            <div class="auth-form-sub">
              Choose a strong password you'll remember.
            </div>

            <form
              [formGroup]="forgotPasswordResetForm"
              (ngSubmit)="submitForgotPasswordReset()"
            >
              <div class="auth-field" style="margin-top: 24px">
                <label class="auth-label">New Password</label>
                <div class="auth-input-wrap">
                  <span class="auth-icon-prefix"
                    ><i class="bi bi-lock"></i
                  ></span>
                  <input
                    [type]="showFpPassword ? 'text' : 'password'"
                    class="auth-icon-input"
                    placeholder="Enter new password"
                    formControlName="newPassword"
                  />
                  <i
                    [class]="showFpPassword ? 'bi bi-eye' : 'bi bi-eye-slash'"
                    (click)="showFpPassword = !showFpPassword"
                    style="
                      position: absolute;
                      right: 15px;
                      top: 50%;
                      transform: translateY(-50%);
                      cursor: pointer;
                      color: #6c757d;
                      font-size: 1.2rem;
                    "
                  ></i>
                </div>
                <small
                  class="auth-error"
                  *ngIf="
                    forgotPasswordResetForm.get('newPassword')?.invalid &&
                    (forgotPasswordResetForm.get('newPassword')?.touched ||
                      forgotPasswordResetForm.get('newPassword')?.dirty)
                  "
                >
                  <div
                    *ngIf="
                      forgotPasswordResetForm.get('newPassword')?.errors?.[
                        'required'
                      ]
                    "
                  >
                    Password is required
                  </div>
                  <div
                    *ngIf="
                      forgotPasswordResetForm.get('newPassword')?.errors?.[
                        'minlength'
                      ]
                    "
                  >
                    Minimum 8 characters required
                  </div>
                  <div
                    *ngIf="
                      forgotPasswordResetForm.get('newPassword')?.errors?.[
                        'passwordStrength'
                      ] &&
                      !forgotPasswordResetForm.get('newPassword')?.errors?.[
                        'minlength'
                      ]
                    "
                  >
                    Password must contain uppercase, lowercase, numbers, and
                    special characters.
                  </div>
                </small>
              </div>

              <div class="auth-field">
                <label class="auth-label">Confirm Password</label>
                <div class="auth-input-wrap">
                  <span class="auth-icon-prefix"
                    ><i class="bi bi-lock"></i
                  ></span>
                  <input
                    [type]="showFpConfirmPassword ? 'text' : 'password'"
                    class="auth-icon-input"
                    placeholder="Re-enter new password"
                    formControlName="confirmPassword"
                  />
                  <i
                    [class]="
                      showFpConfirmPassword ? 'bi bi-eye' : 'bi bi-eye-slash'
                    "
                    (click)="showFpConfirmPassword = !showFpConfirmPassword"
                    style="
                      position: absolute;
                      right: 15px;
                      top: 50%;
                      transform: translateY(-50%);
                      cursor: pointer;
                      color: #6c757d;
                      font-size: 1.2rem;
                    "
                  ></i>
                </div>
                <small
                  class="auth-error"
                  *ngIf="
                    forgotPasswordResetForm.errors?.['passwordMismatch'] &&
                    forgotPasswordResetForm.get('confirmPassword')?.touched
                  "
                >
                  Passwords do not match
                </small>
              </div>

              <button
                type="submit"
                class="auth-submit"
                [disabled]="forgotPasswordResetForm.invalid"
              >
                Reset Password
              </button>
            </form>
          </ng-container>

          <!-- Step 4: Success -->
          <ng-container *ngIf="forgotPasswordStep === 4">
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;
                padding: 20px 0;
              "
            >
              <div
                style="
                  width: 64px;
                  height: 64px;
                  border-radius: 50%;
                  background-color: #e8f5e9;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-bottom: 24px;
                "
              >
                <i
                  class="bi bi-check-circle"
                  style="color: #28a745; font-size: 32px"
                ></i>
              </div>
              <h2
                style="
                  font-size: 1.5rem;
                  font-weight: 800;
                  color: #0f172a;
                  margin-bottom: 12px;
                "
              >
                Password reset successful
              </h2>
              <p
                style="
                  color: #6c757d;
                  font-size: 0.9rem;
                  margin-bottom: 32px;
                  line-height: 1.5;
                "
              >
                Your password has been updated. You can now sign in with your
                new password.
              </p>
              <button
                type="button"
                class="auth-submit"
                (click)="forgotPasswordStep = 0"
                style="width: 100%"
              >
                Login Now
              </button>
            </div>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>
